import * as React from 'react';
import { Link } from 'react-router-dom';
import * as i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

interface NavItem {
    to: string;
    imgSrc: string;
    label: string;
}

const navItems: NavItem[] = [
    { to: '/administrationinfomessages', imgSrc: new URL('../../img/icon-news.png', import.meta.url).href, label: 'admin.news' },
    { to: '/administrationdocuments', imgSrc: new URL('../../img/icon-documents.png', import.meta.url).href, label: 'admin.documents' },
    { to: '/administrationsites', imgSrc: new URL('../../img/icon-building.png', import.meta.url).href, label: 'admin.sites' },
    { to: '/administrationfeedbackmessages', imgSrc: new URL('../../img/icon-feedback.png', import.meta.url).href, label: 'admin.feedback' },
];

function AdminNavigationPage() {
    return (
        <Box>
            <Typography variant="h5" fontWeight={600} gutterBottom>
                {i18next.t('admin.title')}
            </Typography>
            <Divider sx={{ mb: 3 }} />
            <Grid container spacing={3}>
                {navItems.map((item) => (
                    <Grid key={item.to} size={{ xs: 12, sm: 6, md: 3 }}>
                        <Link to={item.to} style={{ textDecoration: 'none' }}>
                            <Card
                                elevation={0}
                                sx={{
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        borderColor: 'secondary.main',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
                                        transform: 'translateY(-2px)'
                                    }
                                }}
                            >
                                <CardActionArea sx={{ textAlign: 'center', py: 3 }}>
                                    <Box sx={{ mb: 2 }}>
                                        <img src={item.imgSrc} alt={i18next.t(item.label)} style={{ filter: 'invert(1)', width: 56, height: 56, objectFit: 'contain' }} />
                                    </Box>
                                    <CardContent sx={{ pt: 0 }}>
                                        <Typography variant="subtitle1" component="h2" fontWeight={600} color="primary">
                                            {i18next.t(item.label)}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

export default withTranslation('translations')(AdminNavigationPage);
